let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8J974")).then(() => parcelRequire('bxCKI'));